import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppMaterialImporterModule } from '../app/app-material-importer.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragAndDropDirective } from './utils/drag-and-drop.directive';
import { CommonDialogComponent } from './components/common-dialog/common-dialog.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { SharedTableComponent } from './components/shared-table/shared-table.component';
import { IntegerDirective } from './directives/integer.directive';
import { FillHandleDirective } from './directives/fill-handle.directive';
import { PrintExportDialogComponent } from './components/print-export-dialog/print-export-dialog.component';
import { PrintColumnSelectionDialogComponent } from './components/print-column-selection-dialog/print-column-selection-dialog.component';
import { PrintPreviewBarComponent } from './components/print-preview-bar/print-preview-bar.component';
import { KitLotFilterDialogComponent } from './components/kit-lot-filter-dialog/kit-lot-filter-dialog.component';
import { RouterModule } from '@angular/router';
import { MatTableExporterModule } from 'mat-table-exporter';
import { SampleDataLoadingDialogComponent } from './components/sample-data-loading-dialog/sample-data-loading-dialog.component';
import { ReportContentSelectComponent } from './components/report-content-select/report-content-select.component';
import { StatusSummaryDialogComponent } from './components/status-summary-dialog/status-summary-dialog.component';
import { RevisionWarningDialogComponent } from './components/revision-warning-dialog/revision-warning-dialog.component';
import { LotExpirationWarningDialogComponent } from './components/lot-expiration-warning-dialog/lot-expiration-warning-dialog.component';
import { SingleRefFileUploadComponent } from './components/single-ref-file-upload/single-ref-file-upload.component';
import { StudyLinkPickerComponent } from './components/study-link-picker/study-link-picker.component';
import { DiscardWarningDialogComponent } from './components/discard-warning-dialog/discard-warning-dialog.component';
import { TokenDialogComponent } from './components/token-dialog/token-dialog.component';
import { ReportItemsImportDialogComponent } from './components/report-items-import-dialog/report-items-import-dialog.component';

/**
 * List of shared components and directives declared in this module.
 */
const UTILITY_COMPONENTS = [
    CommonDialogComponent,
    PrintExportDialogComponent,
    PrintColumnSelectionDialogComponent,
    PrintPreviewBarComponent,
    DragAndDropDirective,
    FileUploadComponent,
    SharedTableComponent,
    IntegerDirective,
    FillHandleDirective,
    KitLotFilterDialogComponent,
    SampleDataLoadingDialogComponent,
    ReportContentSelectComponent,
    StatusSummaryDialogComponent,
    RevisionWarningDialogComponent,
    LotExpirationWarningDialogComponent,
    SingleRefFileUploadComponent,
    StudyLinkPickerComponent,
    DiscardWarningDialogComponent,
    ReportItemsImportDialogComponent,
    // Opened by TokenExpiryService rather than any template. AppModule imports this module
    // eagerly, so declaring it here keeps the dialog resolvable from anywhere in the app.
    TokenDialogComponent,
];

/**
 * SharedUtilitiesModule
 *
 * A feature module that encapsulates and exports reusable components,
 * directives, pipes, and modules across the application.
 *
 * Includes shared dialogs, tables, file upload components, custom directives,
 * and commonly used Angular Material modules.
 */
@NgModule({
    imports: [
        CommonModule,
        AppMaterialImporterModule,
        ReactiveFormsModule,
        FormsModule,
        RouterModule,
        MatTableExporterModule
    ],
    declarations: UTILITY_COMPONENTS,
    exports: [
        CommonDialogComponent,
    PrintExportDialogComponent,
    PrintColumnSelectionDialogComponent,
    PrintPreviewBarComponent,
    DragAndDropDirective,
        FileUploadComponent,
        SharedTableComponent,
        AppMaterialImporterModule,
        IntegerDirective,
        FillHandleDirective,
        KitLotFilterDialogComponent,
        SampleDataLoadingDialogComponent,
        ReportContentSelectComponent,
        StatusSummaryDialogComponent,
        RevisionWarningDialogComponent,
        LotExpirationWarningDialogComponent,
        SingleRefFileUploadComponent,
        StudyLinkPickerComponent,
        DiscardWarningDialogComponent,
        ReportItemsImportDialogComponent
    ]
})
export class SharedUtilitiesModule { }
